import { render, staticRenderFns } from "./VisitServiceMulty.vue?vue&type=template&id=0ccb797d"
import script from "./VisitServiceMulty.vue?vue&type=script&lang=ts"
export * from "./VisitServiceMulty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports